import type { AnalysisDocument } from "@/api/analysis-api";

/**
 * A report an agent finished: every section has stopped running and at least
 * one came back with content. A section that errored doesn't hold the report
 * back — the rest of it is still worth reading, and the Agents tab is where
 * the failed one gets rerun.
 */
export function isAgentReportComplete(document: AnalysisDocument): boolean {
  const { sections } = document;
  return (
    sections.length > 0 &&
    sections.every(
      (section) => section.status === "done" || section.status === "error"
    ) &&
    sections.some((section) => section.status === "done")
  );
}
